export default __webpack_public_path__ + "4e2dc0d293b53de4df92424cf0563d14.ttf";